var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"app-card"},[_c('fude-table',{staticClass:"citizenships",attrs:{"settings":_vm.settings},scopedSlots:_vm._u([{key:"country",fn:function({ item }){return _c('span',{},[_c('span',[_vm._v(_vm._s(item.country_name))])])}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }